export const PUID_KEY =
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name" as const;
